// A place for static vals that are used across multiple components

export const MAX_UPLOAD_SIZE_BYTES = 10485760; // 10MB (bytes)
export const MAX_UPLOAD_SIZE_MB = 10;
export const LARGE_MAX_UPLOAD_SIZE_MB = 64;

export const BYTES_IN_KB = 1024;
export const BYTES_IN_MB = 1024 * 1024;

// SAH - CLIENT BUDGETS - Case Management as a percentage of total_amount
export const CASE_MANAGEMENT_PERCENTAGE = 0.1;
export const CASE_MANAGEMENT_DIVISOR = (1 - CASE_MANAGEMENT_PERCENTAGE) / CASE_MANAGEMENT_PERCENTAGE;

export const CASE_MANAGEMENT_NOTE_TYPE_ID = 73;

export const NO_BUDGET_WARNING = 'NO_BUDGET';
export const STALE_BUDGET_WARNING = 'STALE_BUDGET';
export const NOT_FINALISED_ERROR = 'NOT_FINALISED';

// Polling interval for claim validation status (in milliseconds - 3 seconds)
export const VALIDATION_POLL_INTERVAL_MS = 1000 * 3;

// Hard timeout for claim validation to prevent indefinite polling (in milliseconds - 3 minutes)
export const VALIDATION_TIMEOUT_MS = 1000 * 60 * 3;

// Page size for paginated API requests
export const PAGE_SIZE = 100;

// Document Engine
export const DOCUMENT_TYPES = {
  CO_CONTRIBUTION: {
    SINGLE: 'client-co-contribution',
    COMBINED: 'client-co-contributions',
  },
  SAH_STATEMENT: {
    SINGLE: 'sah-statement',
    COMBINED: 'sah-statements',
  },
} as const;
